import styled from 'styled-components'

export const Container = styled.div<any>`
  position: relative;
  margin: 0 0 20px;
  padding: 2px 20px;
  border-radius: ${props => props.theme.form.borderRadius};
  border: 1px solid ${props => props.theme.form.passiveColor};
  user-select: none;
  cursor: pointer;

  &:hover,
  &:focus {
    box-shadow: ${props => props.theme.form.boxShadow};
  }

  p {
    margin: 18px 0;
  }

  &::before {
    content: ' ';
    position: absolute;
    top: 20px;
    right: 20px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid ${props => props.theme.form.passiveColor};
  }

  &::after {
    content: ' ';
    position: absolute;
    top: 24px;
    right: 24px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${props => props.theme.form.fontColor};
    transform: scale(0);
    transform-origin: 50% 50%;
    transition: transform 300ms ease;
    ${props => props.isSelected && `
      transform: scale(1);
    `}
  }
`
